import { render, staticRenderFns } from "./get-single-role-details.vue?vue&type=template&id=c7369724&"
import script from "./get-single-role-details.vue?vue&type=script&lang=js&"
export * from "./get-single-role-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports